import { useMutation } from '@tanstack/react-query';
import { DOCX_ERRORS, DocxPreviewError, renderDocx } from './utils';
import type { ISanitizedDocx } from './utils';

export const RENDER_DOCX_PREVIEW_KEY = 'renderDocxPreview';

const fetchDocxBlob = async (url: string): Promise<Blob> => {
  const response = await fetch(url, { credentials: 'omit' });
  if (!response.ok) throw new DocxPreviewError(DOCX_ERRORS.download);
  return response.blob();
};

export const useDocxPreview = () => {
  const {
    mutate: renderPreview,
    data: sanitizedDocx,
    isPending: isRenderingPreview,
    error: errorRenderingPreview,
  } = useMutation<ISanitizedDocx, Error, string>({
    mutationKey: [RENDER_DOCX_PREVIEW_KEY],
    mutationFn: async url => renderDocx(await fetchDocxBlob(url)),
  });

  const errorMessage = errorRenderingPreview
    ? errorRenderingPreview instanceof DocxPreviewError
      ? errorRenderingPreview.message
      : DOCX_ERRORS.generic
    : null;

  return { renderPreview, sanitizedDocx, isRenderingPreview, errorMessage };
};
